// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Portal } from "@mui/base";
// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Link,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import outlineImage from "@iconify/icons-ic/outline-image";
import { CallApi, BaseURL } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "title", label: "Title", alignRight: false },
  { id: "descr", label: "Description", alignRight: false },
  // { id: "lineName", label: "Product", alignRight: false },
  { id: "pic", label: "Picture", alignRight: false },
  { id: "items", label: "Items", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Details() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [detailTitle, setDetailTitle] = useState("");
  const [detailTitleErrorText, setDetailTitleErrorText] = useState("");
  const [detailDes, setDetailDes] = useState("");
  const [detailDesErrorText, setDetailDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addDetailLoading, setAddDetailLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [productValue, setProductValue] = useState("");
  const [productValueErrorText, setProductValueErrorText] = useState("");
  const [productList, setProductList] = useState([]);
  const [config, setConfig] = useState(null);
  const [currentDetailItem, setCurrentDetailItem] = useState({
    id: "",
    title: "",
  });
  const [picDialogOpen, setPicDialogOpen] = useState(false);
  const [currentItemsPic, setCurrentItemsPic] = useState(null);
  const [uploadList, setUploadList] = useState([]);

  const navigate = useNavigate();

  // const detailTitleTextField = useRef(null);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    getAllLines();
  }, []);

  const getAllLines = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 1000,
    };
    CallApi("getAllLines", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          setProductList(result.result);
          getAllDetails();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  // useEffect(() => {
  //   if (tableData.length > 0) setDataLoading(false);
  // }, [tableData]);

  const getAllDetails = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
    };
    setDataLoading(true);
    CallApi("getAllDetails", "post", data).then((result) => {
      try {
        console.log(result.result);
        if (result.status === 200) {
          setTableData(result.result);
          setTotalItems(result.paginateInfo.totalItems);
        }
        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) getAllDetails();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClickOpen = () => {
    setDialogMode("add");
    setDetailTitle("");
    setDetailDes("");
    // setProductValue("");
    setUploadList([]);
    setDetailTitleErrorText("");
    setDetailDesErrorText("");
    setProductValueErrorText("");
    setAddDialogOpen(true);
  };

  const addDetail = () => {
    if (!detailTitle) {
      setDetailTitleErrorText("Detail title cannot be empty");
      return;
    } else {
      setDetailTitleErrorText("");
    }

    // if (!productValue) {
    //   setProductValueErrorText("Product cannot be empty");
    //   return;
    // } else {
    //   setProductValueErrorText("");
    // }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      title: detailTitle ? detailTitle : "",
      descr: detailDes ? detailDes : "",
      // lineId: productValue[0],
      pic: uploadList.length > 0 ? uploadList[0].fileName : "",
    };
    let apiname = "createNewDetail";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        detailId: currentDetailItem._id,
        title: detailTitle ? detailTitle : "",
        descr: detailDes ? detailDes : "",
        pic: uploadList.length > 0 ? uploadList[0].fileName : "",
      };
      apiname = "updateDetail";
    }

    console.log(data);
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllDetails();
            setSnackType("success");

            if (apiname === "createNewDetail")
              setSnackbarMessage(
                "'" + detailTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + detailTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentDetailItem(item);
      setDialogMode("update");
      setDetailTitle(item.title);
      setDetailDes(item.descr);
      // setProductValue([item.lineId]);
      setUploadList(
        item.pic
          ? [
              {
                file: { name: item.pic.replace("public/", "") },
                fileName: item.pic,
                status: "ok",
              },
            ]
          : []
      );
      setDetailTitleErrorText("");
      setDetailDesErrorText("");
      setProductValueErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentDetailItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const handleChangeObsoleted = (event) => {
    const {
      target: { value },
    } = event;
    setObsoletedValue(typeof value === "string" ? value.split(",") : value);
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      detailId: currentDetailItem._id,
    };

    setButtonDisabled(true);
    CallApi("removeDetail", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllDetails();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const handleChangeProduct = (event) => {
    const {
      target: { value },
    } = event;
    setProductValue(typeof value === "string" ? value.split(",") : value);
  };

  const onSelectFileComplete = (event) => {
    let files = [];

    for (let i = 0; i < event.target.files.length; i++) {
      // console.log(event.target.files[i]);
      if (
        !event.target.files[i] ||
        (event.target.files[i].type !== "image/jpg" &&
          event.target.files[i].type !== "image/png" &&
          event.target.files[i].type !== "image/webp" &&
          event.target.files[i].type !== "image/jpeg")
      ) {
        setSnackType("error");
        setSnackbarMessage("some files not valid for uploading");
        setSnackbarOpen(true);
        return;
      } else {
        files.push({ file: event.target.files[i], status: "loading" });
      }
    }

    setUploadList(files);
    document.getElementById("selectPicDialog").value = "";
  };

  useEffect(() => {
    if (uploadList.length > 0) {
      let found = false;
      uploadList.forEach((element) => {
        if (!found && element.status === "loading") {
          found = true;
          uploadFile(element.file);
        }
      });
    }
  }, [uploadList]);

  const uploadFile = (file) => {
    const data = new FormData();
    data.append("picture", file);
    data.append("username", getCookie("username"));
    data.append("token", getCookie("token"));

    console.log(file);
    CallApi("uploadPicture", "post", data, true)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "ok", fileName: result.fileName };
              }
              return obj;
            });

            setUploadList(newState);
          } else {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "failed" };
              }
              return obj;
            });

            setUploadList(newState);
          }
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        const newState = uploadList.map((obj) => {
          if (obj.file === file) {
            return { ...obj, status: "failed" };
          }
          return obj;
        });

        setUploadList(newState);
      });
  };

  const onResultClick = (item) => {
    setCurrentItemsPic(item.pic);
    setPicDialogOpen(true);
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Details | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Details
            </Typography>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Detail
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const { _id, title, descr, lineName, pic } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {title}
                              </Typography>
                            </TableCell>
                            <TableCell>{descr ? descr : "-"}</TableCell>
                            {/* <TableCell>{lineName ? lineName : "-"}</TableCell> */}
                            <TableCell align="left">
                              {pic && (
                                <IconButton
                                  aria-label="result"
                                  onClick={() => {
                                    onResultClick(row);
                                  }}
                                >
                                  <Icon icon={outlineImage} fontSize={22} />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell align="left">
                              <Link href={"/details/" + _id}>
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Detail</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentDetailItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Detail" : "Edit Detail"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={detailTitle}
            onChange={(e) => setDetailTitle(e.target.value)}
            disabled={buttonDisabled}
            helperText={detailTitleErrorText}
            error={detailTitleErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Description"
            value={detailDes}
            onChange={(e) => setDetailDes(e.target.value)}
            disabled={buttonDisabled}
            helperText={detailDesErrorText}
            error={detailDesErrorText ? true : false}
          />

          {/* <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled || dialogMode === "update"}
            error={productValueErrorText ? true : false}
          >
            <InputLabel>Product</InputLabel>
            <Select
              value={productValue ? productValue : ""}
              onChange={handleChangeProduct}
              input={<OutlinedInput label="Product" />}
              MenuProps={MenuProps}
            >
              {productList.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{productValueErrorText}</FormHelperText>
          </FormControl> */}

          <Button
            fullWidth
            sx={{ mb: 1 }}
            // onClick={() => setDialogOpen(false)}
            variant="outlined"
            disabled={buttonDisabled}
            startIcon={<CloudUploadIcon />}
            component="label"
          >
            Upload Picture
            <input
              hidden
              accept="image/png,.jpg,.webp"
              // multiple
              type="file"
              onChange={onSelectFileComplete}
              id="selectPicDialog"
            />
          </Button>

          <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {uploadList.map((item, i) => {
              return (
                <Chip
                  disabled={buttonDisabled}
                  key={i}
                  sx={{ mb: 0.5, mr: 0.5 }}
                  icon={
                    item.status === "ok" ? (
                      <CheckIcon />
                    ) : item.status === "failed" ? (
                      <Tooltip title="Retry">
                        <IconButton
                          aria-label="retry"
                          size="small"
                          onClick={() => {
                            const newState = uploadList.map((obj) => {
                              if (obj.file === item.file) {
                                return { ...obj, status: "loading" };
                              }
                              return obj;
                            });

                            setUploadList(newState);
                          }}
                        >
                          <RefreshIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <CircularProgress color="secondary" size={20} />
                    )
                  }
                  label={item.file.name}
                  variant="outlined"
                  color={
                    item.status === "ok"
                      ? "primary"
                      : item.status === "ok"
                      ? "error"
                      : "secondary"
                  }
                  onDelete={
                    item.status === "ok"
                      ? () => {
                          setUploadList((chips) =>
                            chips.filter((chip) => chip.file !== item.file)
                          );
                        }
                      : undefined
                  }
                />
              );
            })}
          </Box>

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addDetail}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={picDialogOpen}
        TransitionComponent={Transition}
        onClose={() => {
          setPicDialogOpen(false);
        }}
      >
        <DialogContent>
          <img alt="" src={BaseURL + currentItemsPic} />
        </DialogContent>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
